module.exports = "/images/wave-pulse.svg?064a42cf816c43b6e9b983e74c97d24f";